
import { Vue, Component } from "vue-property-decorator";
import auth from "@/services/auth";
import { hasuraClient } from "@/plugins/vue-apollo";

@Component
export default class SignOut extends Vue {
  async mounted(): Promise<void> {
    await this.$apollo.provider.defaultClient.cache.reset();
    await auth.signOut();
    hasuraClient.closeSocketConnection();
  }

  beforeDestroy() {
    this.$emit('signOut');
  }
}
